import { t } from "i18next";
import { Button, Form, Modal } from "react-bootstrap";
import { useEffect, useState } from "react";
import { Trans } from "react-i18next";
import { LoadingSpinner } from "../../../general/loading-spinner";
import { deleteProgram, getProgramSingle } from "../../../../services/program";
import { emptyProgram, Program } from "../../../../interfaces/program";

interface ProgramDeleteProps {
    id: number;
    onDelete: CallableFunction;
    onClose: CallableFunction;
}

export function ProgramDelete(props: ProgramDeleteProps) {
    const [program, setTraining] = useState<Program>(emptyProgram);

    const handleDelete = () => {
        deleteProgram(props.id)
            .then(response => {
                props.onDelete(props.id);
            })
            .catch(error => {
                console.log(error);
            });
    }

    const handleClose = () => {
        props.onClose();
    }

    useEffect(() => {
        getProgramSingle(props.id)
            .then(response => {
                setTraining(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }, []);

    return (
        <Modal className="program-delete-container" show={ true }
            onHide={ handleClose }> 
            <Modal.Header closeButton>
                <Modal.Title>
                    { t("Delete program") }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                { program.id == 0 && 
                    <LoadingSpinner />
                }
                { program.id != 0 &&
                    <Form onSubmit={ handleDelete }>
                        <div className="fields">
                            <Trans i18nKey="delete_program_message"
                                values={{
                                    program_name: program.name
                                   }} />
                        </div>
                        <div className="actions">
                            <Button type="submit" variant="primary">
                                { t("Delete") }
                            </Button>
                            <Button variant="secondary" onClick={ handleClose }>
                                { t("Close") }
                            </Button>
                        </div>
                    </Form>
                }
            </Modal.Body>
        </Modal>
    );
}